/**
 * Return array of integer
 * For example, range(5) will return [0, 1, 2, 3, 4]
 * For example, range(5, 10) will return [10, 11, 12, 13, 14]
 */
export function range(length, start = 0) {
  return [...Array(length).keys()].map((number) => number + start);
}
